module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"documentation":"Documentação","help":"Ajuda","status":"Status","privacy":"Privacidade e Segurança","terms-of-use":"Termos de Uso","privacy-policy":"Aviso de Privacidade"},"en-US":{"documentation":"Documentation","help":"Help","status":"Status","privacy":"Privacy and Security","terms-of-use":"Terms of Use","privacy-policy":"Privacy Policy"}}')
  delete Component.options._Ctor
}
